import { pipe } from 'fp-ts/function';
import { array, record } from 'fp-ts';
import { useFormContext } from 'react-hook-form';
import { Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { EnumSelectField } from '@mews-commander/form';
import { BookablePeriod, PortfolioProductOptions, PortfolioPromotions } from '@mews-commander/data-access';
import { getCurrentServiceFieldName, ServicesFieldNames } from '../../formEnums';

interface Props {
    currentService: string;
}
export const ServicesAvailability = ({ currentService }: Props) => {
    const { watch } = useFormContext();

    const filteredProductOptionsEnumClass =
        watch(`${getCurrentServiceFieldName(currentService)}.${ServicesFieldNames.BookablePeriod}`) !==
        BookablePeriod.Month
            ? (pipe(
                  PortfolioProductOptions,
                  record.toEntries,
                  array.filter(([_, type]) => type !== PortfolioProductOptions.ProRataCharging),
                  record.fromEntries
              ) as typeof PortfolioProductOptions)
            : PortfolioProductOptions;
    return (
        <>
            <Typography textStyle="bodyLargeStrong" as="div">
                {lt('ConfigureProductServicesSubHeadingAvailability')}
            </Typography>
            <EnumSelectField
                name={`${ServicesFieldNames.Services}.${currentService}.${ServicesFieldNames.Options}`}
                enumClass={filteredProductOptionsEnumClass}
                enumPrefix="ProductOptions"
                label={lt('ProductOptions')}
                omitHint
                multiselect
            />
            <EnumSelectField
                name={`${ServicesFieldNames.Services}.${currentService}.${ServicesFieldNames.Promotions}`}
                label={lt('ConfigureProductServicesPromotions')}
                enumClass={PortfolioPromotions}
                enumPrefix="Promotions"
                multiselect
                omitHint
            />
        </>
    );
};
